import React from 'react';
import Style from './formPreview.module.css';
import { Input, InputLabel, InputSublabel } from '@weezevent/nacre';

export default function FormInput({ field, label, value = '', id = null, onChangeForm = () => {} }) {
    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
            }
        },
        [id]
    );

    return (
        <div className={Style['field']}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
            <Input {...field} value={value || ''} onChange={({ target: { value } }) => onChange(value)} />
        </div>
    );
}
